export default {
      id: "common__tracking_disabled-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__tracking_disabled",
      toString: function () {
        return this.url;
      }
    }